var HttpStatus;
(function(HttpStatus2) {
  HttpStatus2[HttpStatus2["OK"] = 200] = "OK";
  HttpStatus2[HttpStatus2["Created"] = 201] = "Created";
  HttpStatus2[HttpStatus2["Accepted"] = 202] = "Accepted";
  HttpStatus2[HttpStatus2["NoContent"] = 204] = "NoContent";
  HttpStatus2[HttpStatus2["Moved"] = 301] = "Moved";
  HttpStatus2[HttpStatus2["Found"] = 302] = "Found";
  HttpStatus2[HttpStatus2["BadRequest"] = 400] = "BadRequest";
  HttpStatus2[HttpStatus2["Unauthorized"] = 401] = "Unauthorized";
  HttpStatus2[HttpStatus2["Forbidden"] = 403] = "Forbidden";
  HttpStatus2[HttpStatus2["NotFound"] = 404] = "NotFound";
  HttpStatus2[HttpStatus2["ServerError"] = 500] = "ServerError";
})(HttpStatus || (HttpStatus = {}));
const statusFromCode = (code) => {
  var _a;
  const found = (_a = Object.entries(HttpStatus).find(([, value]) => value === code)) === null || _a === void 0 ? void 0 : _a[0];
  if (!found) {
    return "Unknown";
  }
  if (found === "OK") {
    return found;
  }
  return found.replace(/([A-Z])/g, " $1").trim();
};
const isStatusError = (object) => {
  return typeof object === "object" && !!object && "status" in object && typeof object.status === "number";
};
const httpErrorSymbol = Symbol("http-error");
class HttpError extends Error {
  constructor(status, redirectURL) {
    super(`HTTP error status: ${statusFromCode(status)}`);
    this.status = status;
    this.redirectURL = redirectURL;
    this.__entity = httpErrorSymbol;
  }
  toString() {
    return statusFromCode(this.status);
  }
  get isClientError() {
    return this.status >= 400 && this.status < 500;
  }
  get isServerError() {
    return this.status >= 500 && this.status < 600;
  }
}
const isHttpError = (object) => {
  return !!object && typeof object === "object" && "__entity" in object && object.__entity === httpErrorSymbol;
};
const normalizePath = (path) => {
  return `${path}`.replace(/^\/+|\/+$/g, "");
};
const joinPath = (...paths) => {
  return paths.map(normalizePath).filter(Boolean).join("/");
};
export {
  HttpError,
  isHttpError,
  isStatusError,
  joinPath,
  normalizePath,
  statusFromCode
};
